<template>
	<div>
		<Header :isHome="false"></Header>

		<div class="top-bg" style="padding-top: 3rem;">
			<div class="text-white" :style="`${isMobile?'font-size: 17px;':'font-size: 30px;'}`">Looking for customized Demands</div>
			<div class="text-white" :style="`${isMobile?'font-size: 17px;':'font-size: 30px;'}`">Provide exclusive services</div>
		</div>
		<div class="container" :style="`${isMobile?'padding: 1.5rem;':'padding: 1.5rem 3rem;'}`">
			<div class="df jcsb aic row">
				<div style="font-size: 1rem;color: #000;font-weight: 500;">
					<span class="hover-light" style="cursor: pointer;margin-right: 0.5rem;"
						@click="$router.push({name: 'home'})">Home</span>>
					<span style="margin-left: 0.5rem;">Customized Demands</span>
				</div>
				<div class="search-box" :class="`${isMobile?'col-12':'col-5'}`" @keydown.enter="getData()">
					<input type="text"
						style="border: none;background-color: transparent;color: #000;font-size: 1rem;width: 100%;"
						v-model="searchkeyword" placeholder="Search">
					<img src="../../assets/imgs/search-dark.png" style="width: 1rem;height: 1rem;" @click="getdata()">
				</div>
			</div>
			<div class="main-box wow fadeInUp animated row" style="margin-top: 0.5rem;">
				<div class="df" :class="{fdc:!isMobile,'col-3':!isMobile}">
					<div style="font-weight: bold;font-size: 20px;margin-bottom: 2rem;margin-right: 1rem;">Type</div>
						<el-radio-group v-model="categoryId" @input="getData"> 
							<el-radio :label="undefined" style="margin-top: 0.5rem;" :class="{wm:!isMobile}">All</el-radio>
							<el-radio :label="item.id" v-for="(item, index) in categories" :key="index"
								style="margin-top: 0.5rem;" :class="{wm:!isMobile}">{{item.name}}</el-radio>
						</el-radio-group>
				</div>
				<div class="df fdc" :class="`${isMobile?'col-12':'col-9'}`">
					<div class="items hover-up transition-normal fadeIn" v-for="(item, index2) in data" :key="index2"
						@click="$router.push({name: 'demandDetails',query:{id:item.id}})">
						<div class="df aic">
							<img class="avatar"
								:src="item.user.avatar" alt="" />
							<div class="user-name" v-text="item.user?item.user.username:''"></div>
						</div>
						<div class="title text_over_2line">{{item.title}}</div>
						<div class="subTitle text_over_2line">{{item.sub_title}}</div>
					</div>
				</div>
			</div>
			<pagination :page="page" :page-size="perPage" :total="nowtotal||0" :on-page-change="onPage"
				:pageSizeList="[]" class="pagi page-content" />
		</div>
		<Footer style="margin-top: 3rem;"></Footer>
	</div>
</template>

<script>
	import Header from '/src/components/header.vue'
	import Footer from '/src/components/footer.vue'
	import Pagination from '@/components/pagination.vue';
	export default {
		data() {
			return {
				active: 0,
				isMobile: false,
				data: [],
				page: 1,
				perPage: 6,
				nowtotal: 0,
				searchkeyword: null,
				categories: '',
				categoryId: undefined,
				isMobile:false
			}
		},
		components: {
			Header,
			Footer,
			Pagination
		},
		mounted() {
			this.isMobile = localStorage.getItem('isMobile') == 'null' ? false : true
			this.getData();
			this.getList();
		},
		methods: {
			async getList() {
				let res = await this.$get('/categories')
				this.categories = res.data.items
			},
			async getData() {
				let {
					data: {
						items,
						total
					}
				} = await this.$get('/gci/product/customs', {
					page: this.page,
					perPage: this.perPage,
					categoryId: this.categoryId,
					keyword:this.searchkeyword,
					status:2
				});
				this.nowtotal = total;
				this.data = items;
			},
			// 分页
			onPage(pageNow) {
				this.page = pageNow;
				window.scrollTo(0, 0);
				this.getData()
			},
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width:767px) {
		/deep/ .el-radio-group{
			overflow-x: scroll !important;
			display: flex;
			max-width: 40%;
		}
		.top-bg{
			height: 240px !important;
		}
	}
	
	
	/deep/ .el-radio__input.is-checked .el-radio__inner {
		background-color: #32FCDA;
		color: #32FCDA;
	}

	/deep/ .el-radio__input.is-checked+.el-radio__label {
		color: #000;
	}

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #ccc;
	}

	div {
		box-sizing: border-box;
	}

	.radio {
		border-radius: 50%;
		border: 1px solid #000;
		width: 1rem;
		height: 1rem;
		margin-right: 0.7rem;
	}

	.avatar {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		margin-right: 0.5rem;
	}

	.items {
		cursor: pointer;
		padding: 1rem;
		margin-top: 1rem;
		border-radius: 0.5rem;
		border: 1px solid #e8e8e8;
	}

	.user-name {
		font-size: 20px;
		font-weight: bold;
	}

	.top-bg {
		width: 100vw;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		background-image: url('../../assets/imgs/Group 6841.png');
		background-size: cover;
		background-position: top top;
		background-repeat: no-repeat;
		flex-direction: column;
		height: 360px;
	}

	.text-white {
		color: #fff;
	}

	.bg-white {
		background-color: #fff;
	}

	.label {
		font-weight: bold;
		margin: 1rem 0;
	}

	.title {
		font-size: 1.5rem;
		margin: 0.5rem 0;
		font-weight: bold;
	}

	.search-box {
		height: 2.5rem;
		background-color: #fff;
		margin-top: 1rem;
		border-radius: 5rem;
		padding: 0 1rem;
		display: flex;
		align-items: center;
		border: 1px solid #e8e8e8;
	}
</style>